<template>
  <button @click="openDrawer" class="btn btn-default" type="button">
    <i class="icon-fa icon-fa-cc-visa"/>
  </button>
</template>

<script>

export default {
  props: ['order'],
  data() {
    return {
      open: false
    }
  },
  methods: {
    openDrawer() {
      this.$store.dispatch('platform/setGlobalDrawerData', {
        data: {
          order: {...this.order},
          type: 'prePaid'
        },
        // callBackAction: 'refreshList'
      })
    }
  }
}

</script>

<style scoped>

i.icon-fa {
  color: #4fc47f;
}
</style>
